import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import Loan_Schemes2Header from './Loan_Schemes2Header'
import Loan_SchemesCreate from './Loan_SchemesCreate'

const Loan_Schemes = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <Loan_Schemes2Header />
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <Loan_SchemesCreate />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default Loan_Schemes